import { ButtonColor, CommonActionKey, SimpleDialogData } from "common";

export const getConfirmDialogData = (loanNumber: string): SimpleDialogData => ({
	title: "Clear cache?",
	body: `This will clear the agreement cache for account ${loanNumber}.`,
	actions: [
		{ label: "CANCEL", buttonColor: ButtonColor.Default, actionKey: CommonActionKey.Cancel },
		{ label: "CONFIRM", buttonColor: ButtonColor.Primary, actionKey: CommonActionKey.Confirm }
	],
	config: {
		width: "520px"
	}
});

export const getNoDocsResultDialogData = (loanNumber: string): SimpleDialogData => {
	return {
		title: "Action cannot be done",
		body: `Document cache was not cleared because there are no cached documents for account ${loanNumber}.`
	}
};

export const getClearCacheSuccessDialogData = (loanNumber: string, clearedDocs: number): SimpleDialogData => {
	return {
		title: "Success",
		body: `Document cache was cleared for account ${loanNumber}. <br>${clearedDocs} document${clearedDocs === 1 ? ' was' : 's were'} removed.`,
	}
};